import { render, staticRenderFns } from "./EmployeeLeaveCredits.vue?vue&type=template&id=32dd25fe&scoped=true"
import script from "./EmployeeLeaveCredits.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveCredits.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaveCredits.vue?vue&type=style&index=0&id=32dd25fe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd25fe",
  null
  
)

export default component.exports